<template>
    <main class="w-100">
      <LoadingSpinner v-if="!completeLoading" />
      <div v-else>
        <div class="col-12 px-0">
          <h4>New Tasks</h4>
          <div
            class="container-fluid w-100 mb-3 p-3 border bg-white rounded stats-wrapper"
          >
            <div class="d-flex flex-wrap">
              <!-- FILA 1 -->
  
              <!-- DATE FROM -->
              <div class="w-50 input-group input-group-sm p-1">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >From</span
                  >
                </div>
                <date-picker
                  id="startDatePicker"
                  class="form-control"
                  v-model="filters.range.startDate"
                  :config="datePickerConfig"
                  placeholder="Start Date"
                ></date-picker>
  
                <!-- DATE TO -->
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >to</span
                  >
                </div>
                <date-picker
                  id="endDatePicker"
                  class="form-control"
                  v-model="filters.range.endDate"
                  :config="datePickerConfigEndDate"
                  placeholder="End Date"
                ></date-picker>
              </div>
  
              <!-- FILA 2 -->
              <!-- BDR -->
              <!-- <div
                class="w-50 input-group input-group-sm p-1 treeselect-wrapper"
                v-if="['1','9'].includes(currentUser.role_id)"
              >
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >BDR</span
                  >
                </div>
                <treeselect
                  v-model="filters.bdrUserFilter"
                  :options="bdrUserOptions"
                  :normalizer="normalizeOptions"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div> -->
  
              <!-- FILA 3 -->
  
              <!-- TASK TYPE -->
              <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >{{ $t("lang.label.filter-task_type") }}</span
                  >
                </div>
                <treeselect
                  v-model="filters.taskTypeFilter"
                  :options="taskTypeOptions"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div>

                <!-- TASK STATUS -->
                <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >{{ $t("lang.label.filter-task_status") }}</span
                  >
                </div>
                <treeselect
                  v-model="filters.taskStatusFilter"
                  :options="taskStatuses"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div>
  
              <!-- FILTER TEMPERATURE -->
              <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >{{ $t("lang.label.filter-temperature_status") }}</span
                  >
                </div>
                <treeselect
                  v-model="filters.temperatureStatusFilter"
                  :options="temperatureStatuseOptions"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div>
  
              <!-- OPP STATUS -->
              <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >{{ $t("lang.label.filter-opp_status") }}</span
                  >
                </div>
                <treeselect
                  v-model="filters.oppStatusFilter"
                  :options="oppStatusOptions"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div>

              <!-- FILTER CLIENT -->
              <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >{{ $t("lang.label.client") }}</span
                  >
                </div>
                <treeselect
                  v-model="filters.clientFilter"
                  :options="clientsFiltered"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div>
  
              <!-- MEETING -->
              <!-- <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >Meeting Planned</span
                  >
                </div>
                <treeselect
                  v-model="filters.withMeeting"
                  :options="withMeetingOptions"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div> -->
  
              <div class="w-25 p-1 ml-auto">
                <div class="col-md-12 d-flex justify-content-end my-2">
                  <button
                    class="btn btn-success"
                    :disabled="!completeLoading"
                    @click="getBdrTaskList()"
                  >
                    <i class="icon-calendar-check-o mr-2"></i>
                    <small>
                      {{ $t("lang.label.letsgetstarted") }}
                    </small>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-12 w-100 mb-3 card p-2">
          <div v-if="completeLoading && total > 0" class="row">
            <div class="col-12">
              <div class="bd-highlight">
                {{ $t("lang.label.results") }}:
                <small v-if="!total" class="ml-1 text-primary"
                  >{{ $t("lang.search.calculating") }}...</small
                >
                <strong v-else>{{ total }}</strong>
                <button class="ml-2 btn btn-sm btn-primary" 
                    @click="getToDownload()"
                    :disabled="processingAllItems"
                    >
                    <span v-if="!processingAllItems">
                      Download csv
                    </span>
                    <span v-else>Processing...</span>
                </button>
              </div>
              <div class="text-center mb-2">
                <Pagination
                  :total="total"
                  :totalpage="bdrTaskListQty"
                  :model="pagination"
                  :limit="false"
                  :color="'primary'"
                  @changePage="getBdrTaskList"
                  key="paginationkey"
                ></Pagination>
              </div>
            </div>
          </div>
    
          <div class="col-12 px-0 mx-0 table-responsive">
            <Table
              :key="3232323"
              :headers="simpleheader"
              :cols="simplecols"
              :data="list"
              :checkbox="false"
              :notselect="true"
              :model="[]"
              @goToOpportunity="goToOpportunity"
              @goToAgency="goToAgency"
              @openTarget="openTarget"
            >
            </Table>
          </div>
        </div>
      </div>
    </main>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  import LoadingSpinner from "@/components/LoadingSpinner.vue";
  import { notificationService, usersService, monitorService } from "@/_services";
  import Table from "@/components/Common/Table.vue";
  import Pagination from "@/components/Common/Pagination.vue";
  import moment from "moment";
  import Treeselect from "@riophae/vue-treeselect";
  import "@riophae/vue-treeselect/dist/vue-treeselect.css";
  import { statusBadgeMixin } from "@/_mixins/";
  
  export default {
    name: "BdrNewTasks",
    components: { Table, Pagination, LoadingSpinner, Treeselect },
    props: {
      condition: {
        type: String,
        default: "all",
      },
      targetId: {
        type: String,
        default: '0'
      }
    },
    mixins: [statusBadgeMixin],
    computed: {
      capitalizeFirstLetter() {
        return (word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        };
      },
    },
    data() {
      return {
        withMeetingOptions: [
          { id: 1, label: this.$t("lang.button.yes") },
          { id: 0, label: this.$t("lang.label.no") },
        ],
        processingAllItems: false,
        completeLoading: false,
        total: 10,
        pagination: {
          imported: false,
          refreshlist: false,
          selectfirst: false,
          cantPerPage: 25,
          currentPage: 1,
        },
        list: [],
        listAllItems: [],
        bdrUserOptions: [],
        clientsFiltered: [],
        taskStatuses: [
          {
            id: "1",
            label: "Todo",
          },
          {
            id: "2",
            label: "Done",
          },
        ],
        taskTypeOptions: [
          {
            id: "coldphoning",
            label: this.$t("lang.task.callcontact_title"),
          },
          {
            id: "manualanswer",
            label: this.$t("lang.task.manualanswer_title"),
          },
          {
            id: "reminder",
            label: "Reminder Task",
          },
          {
            id: "absent",
            label: "Absent Event",
          },
          {
            id: "calendar",
            label: "Calendar activity with no event",
          },
          {
            id: "cancelled",
            label: "Cancelled Event",
          },
        ],
        temperatureStatuseOptions: [
          {
            id: "1",
            label: "Urgent",
          },
          {
            id: "2",
            label: "Positive",
          },
          {
            id: "3",
            label: "Introduction",
          },
          {
            id: "4",
            label: "Wrong contact",
          },
          {
            id: "5",
            label: "Negative",
          },
          {
            id: "6",
            label: "Calendar inspection",
          },
          {
            id: "7",
            label: "Reschedule",
          },
          {
            id: "8",
            label: "Cold",
          },
          {
            id: "9",
            label: "Other Answer",
          },
        ],
        oppStatusOptions: [
          {
            id: "canceled",
            label: "Canceled",
          },
          {
            id: "absent",
            label: "Absent",
          },
          {
            id: "on",
            label: "On",
          },
          {
            id: "off",
            label: "Off",
          },
        ],
        domainhttpsindex: 32322332,
        lastFilters: [],
        filters: {
          taskStatusFilter: [],
          bdrUserFilter: [],
          taskTypeFilter: [],
          oppStatusFilter: [],
          temperatureStatusFilter: [],
          clientFilter: [],
          targetId: this.targetId,
          withMeeting: [],
          range: {
            startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          },
        },
        simpleheader: [
          {
            label: this.$t("lang.column.creationdate"),
            class: "overflowhide",
          },
          {
            label: "Type",
            class: "overflowhide",
          },
          {
            label: "Tasks Done",
            class: "overflowhide",
          },
          {
            label: "Opportunity ID",
            class: "overflowhide",
          },
          {
            label: "Opportunity created",
            class: "overflowhide",
          },
          {
            label: "Opportunity",
            class: "overflowhide",
          },
          {
            label: "Target",
            class: "overflowhide",
          },
          {
            label: "Client",
            class: "overflowhide",
          },
          {
            label: "Client Status",
            class: "overflowhide",
          },
          {
            label: "Opportunity Temperature",
            class: "overflowhide",
          },
          {
            label: "Status",
            class: "overflowhide",
          },
          {
            label: "Meeting",
            class: "overflowhide",
          },
        ],
        simplecols: [
          [
            {
              value: "created",
              class: "text-primary",
            },
          ],
          [
            {
            value: "task_type",
            class: "text-primary",
            },
          ],
          [
            {
            value: "tasks_done",
            class: "text-primary",
            },
          ],
          [
            {
              value: "link_id",
            },
          ],
          [
            {
            value: "opportunity_created",
            class: "text-primary",
            },
          ],
          [
            {
              value_label: "business_name",
              value_emit: "link_id",
              class: "text-primary",
              type: "emit",
              emit: "goToOpportunity",
            },
          ],
          [
            {
              value_label: "target_name",
              value_emit: "target_id",
              class: "text-primary",
              textShort: 40,
              type: "emit",
              emit: "openTarget",
            },
          ],
          [
            {
              value_label: "client_name",
              value_emit: "client_id",
              class: "text-primary",
              type: "emit",
              emit: "goToAgency",
            },
          ],
          [
            {
              value: "client_status",
            },
          ],
          [
            {
              value: "link_status_temperature_id",
              type: "itemBadge",
              class: "badge badge-primary",
              colors: [
                {
                  id: 1,
                  label: "Urgent",
                  bgColor: "#008000",
                  textColor: "#FFFFFF",
                },
                {
                  id: 2,
                  label: "Positive",
                  bgColor: "#008000",
                  textColor: "#FFFFFF",
                },
                {
                  id: 3,
                  label: "Introduction",
                  bgColor: "#0000FF",
                  textColor: "#FFFFFF",
                },
                {
                  id: 4,
                  label: "Wrong Contact",
                  bgColor: "#0000FF",
                  textColor: "#FFFFFF",
                },
                {
                  id: 5,
                  label: "Negative",
                  bgColor: "#0000FF",
                  textColor: "#FFFFFF",
                },
                {
                  id: 6,
                  label: "Calendar Inspection",
                  bgColor: "#00FFFF",
                  textColor: "#000000",
                },
                {
                  id: 7,
                  label: "Reschedule",
                  bgColor: "#FFFF00",
                  textColor: "#000000",
                },
                {
                  id: 8,
                  label: "Cold",
                  bgColor: "#000000",
                  textColor: "#FFFFFF",
                },
                {
                  id: 9,
                  label: "Other Answer",
                  bgColor: "#FF9966",
                  textColor: "#000000",
                },
              ],
            },
          ],
          [
            {
              value: "task_status",
              type: "itemBadge",
              class: "badge badge-primary",
              colors: [
                {
                  id: 1,
                  label: "ToDo",
                  bgColor: "orange",
                  textColor: "black",
                },
                {
                  id: 2,
                  label: "Done",
                  bgColor: "green",
                  textColor: "white",
                },               
              ],
            },
          ],            
          [
            {
              value: "has_event_valid",
              type: "status",
              icon_to_true: "icon-checkmark text-success",
              icon_to_false: null
            },            
          ],
        ],
        datePickerConfig: {
          format: "YYYY-MM-DD",
          useCurrent: false,
          // minDate: moment().startOf("day")
          maxDate: moment().endOf("day"),
        },
        datePickerConfigEndDate: {
          format: "YYYY-MM-DD",
          useCurrent: false,
          maxDate: moment().endOf("day"),
        },
      };
    },
    created() {
      //this.getUserBdr();
      this.getClients();
      this.getBdrTaskList();
    },
    computed: {
      bdrTaskListQty() {
        return this.list.length;
      },
      ...mapState({
        currentUser: (state) => state.authentication.user,
      }),
    },
    methods: {
      getToDownload() {
        const allItems = 1; // cuando quieres pedir todos los resultados sin limite
        this.getBdrTaskList(allItems);
      },
      download() {   

        const nameDocument = "report-booker-new-tasks.csv";

        //Tomo headers desde simpleheader
        const headers = this.simpleheader.map(h => h.label);
        
        const fields = this.simplecols.map( item => {
          const value = (item[0].value) ? item[0].value : item[0].value_label;
          return value;
        })

        const rows = this.listAllItems.map( item => {
          return fields.map( col => {
            return item[col];
          }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
        })

        const csv = `${headers.join(",")}\n${rows.join("\n")}`;
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", nameDocument);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      isBdrUser() {
        if (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2) {
          this.bdr_user_id = this.currentUser.id;
          return true;
        } else {
          return false;
        }
      },
      getUserBdr() {
        if (this.isBdrUser()) {
          return false;
        }
        // this.selectUserBdr = false
        usersService
          .getBdrs()
          .then((res) => {
            this.bdrUserOptions = res.result;
            // this.selectUserBdr = true
          })
          .catch((err) => consolelog(err));
      },
      getClients() {
        monitorService
          .getClients()
          .then((response) => {
            this.clientsFiltered = response.map((client) => ({
              id: client.id,
              label: client.name,
            }));
          })
          .catch((err) => console.log(err));
      },
      normalizeOptions(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
      getBdrTaskList(allItems = 0) {
        if (JSON.stringify(this.filters) != JSON.stringify(this.lastFilters)) {
          this.getBdrTaskTotal();
        }
  
        const taskOutputList = [
          "Meeting Booked",
          "Call back",
          "No answer",
          "No phone",
          "No interest",
        ];

        if(allItems === 0) {
          this.completeLoading = false;
        } else {
          this.processingAllItems = true;
        }          
  
        
        let filters = this.filters;
        filters.cantPerPage = this.pagination.cantPerPage;
        filters.currentPage = this.pagination.currentPage;
        filters.getTotal = 0;        
        filters.allItems = allItems
        
        notificationService.getBdrNewTaskList(filters).then((result) => {
          if(allItems === 1) {
            if (result) {
            this.listAllItems = result.map( el => ({ ...el, link_status_temperature_id: (el.link_status_temperature_id) ? el.link_status_temperature_id : 'empty'  }));
            this.listAllItems.forEach((item) => {
              item.task_type = this.getTaskTypeTitle(item.task_type);
              item.task_output = (item.task_output != null) ? taskOutputList[item.task_output - 1] : 'empty';
                           
              });
            } else {
              this.notifications = [];
              this.total = 0;
            }
            this.lastFilters = JSON.parse(JSON.stringify(this.filters));
            //this.completeLoading = true;      
            this.download();      
            this.processingAllItems = false
          } else {
            if (result) {
            this.list = result.map( el => ({ ...el, link_status_temperature_id: (el.link_status_temperature_id) ? el.link_status_temperature_id : 'empty'  }));
            this.list.forEach((item) => {
              item.task_type = this.getTaskTypeTitle(item.task_type);
              item.task_output = (item.task_output != null) ? taskOutputList[item.task_output - 1] : 'empty';
                           
              });
            } else {
              this.notifications = [];
              this.total = 0;
            }
            this.lastFilters = JSON.parse(JSON.stringify(this.filters));
            this.completeLoading = true;
          }
          
        });
      },
      getBdrTaskTotal() {
        this.pagination.currentPage = 1;
        this.total = 0;
        let filters = this.filters;
        filters.cantPerPage = this.pagination.cantPerPage;
        filters.currentPage = this.pagination.currentPage;
        filters.getTotal = 1;
        notificationService.getBdrNewTaskList(filters).then((result) => {
          this.total = result.total;
        });
      },
      openTarget(order_id) {
        let url = "/orders/" + order_id;
        window.open(url, "_blank");
      },
      goToOpportunity(link_id) {
        window.open("/opportunities/" + link_id, "_blank");
      },
  
      goToAgency(client_id) {
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      },
  
      getTaskTypeTitle(title) {
        if (title.indexOf("lang.") !== -1) {
          let message = JSON.parse(title);
          return this.$t(message.lang_message);
        }
        return title;
      },
    },
  };
  </script>
  